
import React from 'react';
import { Plus, Sparkles } from 'lucide-react';
import PromptCard from './PromptCard';




// Home Page Component
const HomePage = ({ history, onNavigate, onCopyPrompt, onDeletePrompt }) => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-8 mt-16">
      <div className="text-center mb-12 animate-fade-in">
        <h2 className="text-4xl font-bold text-white mb-4">
          Bienvenue sur PromptStudio
        </h2>
        <p className="text-gray-400 text-lg max-w-2xl mx-auto">
          Générez des prompts marketing professionnels en quelques secondes. Parfait pour vos campagnes Instagram, TikTok, Facebook Ads et bien plus encore.
        </p>
      </div>

      {/* CTA Button */}
      <div className="flex justify-center mb-12">
        <button
          onClick={() => onNavigate('generator')}
          className="group px-8 py-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-xl font-semibold text-white shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 flex items-center space-x-3"
        >
          <Plus className="w-5 h-5" />
          <span>Créer un Nouveau Prompt</span>
        </button>
      </div>

      {/* History Section */}
      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <h3 className="text-2xl font-bold text-white">Historique</h3>
          {history.length > 0 && (
            <span className="text-gray-500 text-sm">{history.length} prompt(s) sauvegardé(s)</span>
          )}
        </div>

        {history.length === 0 ? (
          <div className="bg-white/5 backdrop-blur-xl rounded-xl p-12 border border-white/10 text-center">
            <Sparkles className="w-16 h-16 text-gray-600 mx-auto mb-4" />
            <h4 className="text-xl font-semibold text-gray-400 mb-2">
              Aucun prompt généré pour le moment
            </h4>
            <p className="text-gray-500 mb-6">
              Créez votre premier prompt pour le voir apparaître ici
            </p>
            <button
              onClick={() => onNavigate('generator')}
              className="px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg text-white font-medium transition-colors"
            >
              Créer mon premier prompt
            </button>
          </div>
        ) : (
          <div className="grid gap-6">
            {history.map(prompt => (
              <PromptCard
                key={prompt.id}
                prompt={prompt}
                onCopy={onCopyPrompt}
                onDelete={onDeletePrompt}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
export default HomePage;